// extracted by mini-css-extract-plugin
export default {"faves":"AnimeFave_faves__ewhOz","error":"AnimeFave_error__M0kfL"};